import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from '../models/index';
import { AppConstants } from '../constant/app.constants';

@Injectable()
export class UsersService {
    constructor(private http: HttpClient) {
    }

    getAllClients() {
        return this.http.get<any>(AppConstants.SITE_URL +'user/get_all_clients');
    }
    getAllUser() {
        return this.http.get<any>(AppConstants.SITE_URL +'user/get_all_users');
    }
    getUsers(user: User) {
        return this.http.post<any>(AppConstants.SITE_URL +'user/get_users', user);
    }
    getClients(user: User) {
        return this.http.post<any>(AppConstants.SITE_URL +'user/get_clients', user);
    }
    changeUserStatus(id, status) {
        return this.http.post<any>(AppConstants.SITE_URL +'user/changeUserStatus', { id: id, status: status });
    }
    getUserById(id) {
        return this.http.post<any>(AppConstants.SITE_URL +'user/getUserById', { id: id });
    }
    saveUser(user) {
        return this.http.post<any>(AppConstants.SITE_URL +'user/saveuser', user);
    }
    CheckUserEmail(user) {
        return this.http.post<any>(AppConstants.SITE_URL +'user/checkemailuser', user);
    }
    deleteUser(id) {
        return this.http.post<any>(AppConstants.SITE_URL +'user/deleteUser', { id: id });
    }
    getUserByRoleId(id) {
        return this.http.post<any>(AppConstants.SITE_URL +'user/getUserByRoleId', { id: id });
    }


}



// WEBPACK FOOTER //
// /var/www/delios/delios-live/app/src/app/services/users.service.ts